import { END } from '@confluence/navdex/entry-points/NavdexPointType.ts';

export const navdexEnd = {
	attributes: {
		navdexPointType: END,
	},
};
